<template>
  <div class="banner_box" :class="bannerClass"></div>
</template>

<script>
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberBanner',
  mixins: [mixin],
  computed: {
    bannerClass() {
      if (this.isNewUserStatus) {
        return 'style_1' // 新客
      } else if (!this.isNewUserStatus && !this.isFromTab) {
        return 'style_2' // 老客 非 tab页
      } else if (!this.isNewUserStatus && this.isFromTab) {
        return 'style_3' // 老客 tab页
      }
      return 'style_4' // 兜底
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.banner_box {
  width: 100%;
  &.style_1 {
    padding-top: 404px;
  }
  &.style_2 {
    padding-top: 204px;
  }
  &.style_3 {
    padding-top: 126px;
  }
  &.style_4 {
    padding-top: 204px;
  }
}
</style>
